import { useMemo, useRef } from 'react';
import { useSearchStore } from '../../state/searchStore';
import { setActiveDataRole } from '../../state/actions/searchParams';
import { useUserDataStore } from '@/services/firebase/state/userDataStore';

export const DataRoleToggle = () => {
  const { data: userData } = useUserDataStore();

  const sortedDataRoles = useMemo(() => {
    if (userData) {
      return [...userData.storedUser.dataRoles].sort((a, b) => a.weight - b.weight);
    }
    return [];
  }, [userData]);

  const selectedDataRole = useSearchStore((s) => s.currentParams.dataRole);

  const visible = sortedDataRoles.length > 1;
  const wasVisibleRef = useRef(visible);

  const selectDataRole = (roleId: string) => {
    setActiveDataRole(roleId);
  };

  return (
    <div className="flex gap-2 h-6">
      {visible &&
        sortedDataRoles.map((role) => {
          return (
            <div
              className={`flex ${wasVisibleRef.current ? '' : 'animate-fade-in'}`}
              key={role.roleName}>
              <p
                className={`flex items-center text-tiny font-medium ${
                  role.roleName === selectedDataRole
                    ? 'bg-black rounded-full text-white'
                    : 'cursor-pointer border rounded-full'
                } px-3`}
                onClick={() => selectDataRole(role.roleName)}>
                {role.label}
              </p>
            </div>
          );
        })}
    </div>
  );
};
